(function (angular) {
	'use strict';

	angular.module('PinMeTo.services').service('pmtFilterService', [
		'$http',
		function pmtFilterService($http) {
			this.listenOnFilter = ($ctrl, $state) => {
				let filterCache = {};

				$ctrl.subscriptions = ($ctrl.subscriptions || []).concat([
					{
						id: 'onFilter',
						f: async filter => {
							if ($ctrl.onFilter) {
								$ctrl.onFilter({ filter });
							}

							let filterString = filter.filterDefinition?.length ? JSON.stringify(filter) : null;
							if (filterString?.length > 1024) {
								if (filterCache[filterString]) {
									filterString = filterCache[filterString];
								} else {
									const res = await $http.post(`/api/filter/${$state.params.site}/shorten`, {
										filterString
									});
									filterString = res.data.key;
									filterCache[filterString] = res.data.key;
								}
							}

							$state.go(
								$state.current,
								{
									filter: filterString
								},
								{
									location: 'replace'
								}
							);
						}
					}
				]);
			};
			this.parseFilter = async $stateParams => {
				try {
					return JSON.parse($stateParams.filter);
				} catch {
					if ($stateParams.filter?.length) {
						try {
							const res = await $http.get(
								`/api/filter/${$stateParams.site}/shorten?key=${$stateParams.filter}`
							);
							return JSON.parse(res.data.filterString);
						} catch {
							return null;
						}
					}
					return null;
				}
			};
		}
	]);
})(window.angular);
